import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import CategoryCard from '@/components/feature/CategoryCard';
import ArticleCard from '@/components/feature/ArticleCard';
import SchemaOrg from '@/components/feature/SchemaOrg';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';
import { useState } from 'react';

const faqData = [
  {
    q: "大胸姐妹应该多久更换一次内衣？",
    a: "如果有4-5件内衣轮流穿着，建议每6-9个月更换一轮；如果只有2-3件高频轮换，4-6个月就需要更换。运动内衣因为拉伸更大，3-6个月就应更换。一旦出现下围变松、钢圈变形、肩带失去弹性等信号，说明该换新了。",
  },
  {
    q: "无肩带内衣大胸能穿吗？会不会掉？",
    a: "完全可以！关键在于选对款式：选择下围有防滑硅胶条、侧翼高度12cm以上、后背至少四排扣的款式。长款塑身型或U型钢圈款是大胸最稳妥的无肩带选择。只要选对尺寸和款式，一天下来都不会滑落。",
  },
  {
    q: "大胸姐妹穿什么内衣最显瘦？",
    a: "全罩杯+侧收设计的内衣最显瘦。全罩杯将乳房完整包裹避免溢出，侧收功能将乳房向中间集中，正面看起来更利落。搭配V领上衣可以在视觉上拉长颈部线条，显瘦效果加倍。",
  },
  {
    q: "运动时大胸晃动厉害怎么办？",
    a: "必须选择高强度支撑的运动内衣，关键看三点：包裹式设计（encapsulation）优于压缩式、肩带要宽且有缓冲垫、后背工字或交叉设计。D杯以上做跑步、跳绳等高冲击运动时，普通内衣完全不够用。",
  },
  {
    q: "如何判断内衣尺码是否合适？",
    a: "合适的尺码表现为：下围不勒但稳固（能塞进两指为佳）、钢圈完整包裹乳房不压不空、罩杯填满无溢出或空杯、肩带不掉不勒。如果出现勒痕、空杯、肩带滑落任一问题，说明尺码需要调整。",
  },
];

export default function Home() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  const featuredArticles = articles.slice(0, 6);

  return (
    <>
      <ScrollToTop />
      <SchemaOrg
        type="WebSite"
        data={{
          name: "大胸姐妹指南",
          url: `${window.location.origin}${__BASE_PATH__}/`,
          description: "专为大胸姐妹打造的内衣选购指南，从罩杯尺码测量、肩带支撑到日常穿搭，全面解决大胸姐妹在内衣选择中遇到的痛点。",
          inLanguage: "zh-CN",
        }}
      />
      <SchemaOrg
        type="Organization"
        data={{
          name: "大胸姐妹指南",
          url: `${window.location.origin}${__BASE_PATH__}/`,
          description: "专为大胸姐妹打造的内衣选购与穿搭知识平台。",
        }}
      />
      <SchemaOrg
        type="FAQPage"
        data={{
          mainEntity: faqData.map((item) => ({
            '@type': 'Question',
            name: item.q,
            acceptedAnswer: {
              '@type': 'Answer',
              text: item.a,
            },
          })),
        }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20artistic%20abstract%20fashion%20editorial%20background%20with%20soft%20flowing%20fabric%20in%20warm%20cream%20and%20blush%20pink%20tones%2C%20delicate%20textures%2C%20minimalist%20feminine%20aesthetic%2C%20soft%20natural%20lighting%2C%20dreamy%20atmosphere%2C%20clean%20artistic%20composition%20with%20gentle%20shadows&width=1800&height=1000&seq=hero-main-2026&orientation=landscape"
              alt="大胸姐妹专属内衣指南"
              title="大胸姐妹专属内衣指南 - 舒适支撑全攻略"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
            <div className="absolute inset-0 flex items-center justify-center px-4">
              <div className="text-center w-full max-w-3xl">
                <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-background-50 mb-4 md:mb-6 leading-tight">
                  大胸姐妹专属内衣指南
                </h1>
                <p className="text-sm md:text-lg text-background-50/90 mb-6 md:mb-8 max-w-2xl mx-auto leading-relaxed">
                  专为大胸姐妹打造的内衣选购指南，从罩杯尺码测量、肩带支撑到日常穿搭，全面解决大胸姐妹在内衣选择中遇到的痛点，找到真正合身、舒适、显瘦的内衣方案。
                </p>
                <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                  <Link
                    to="/category/zhao-bei-ce-liang"
                    className="px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    开始探索 →
                  </Link>
                  <Link
                    to="/about"
                    className="px-6 py-3 bg-background-50/20 text-background-50 backdrop-blur-sm rounded-full text-sm font-medium hover:bg-background-50/30 transition-colors border border-background-50/30 whitespace-nowrap cursor-pointer"
                  >
                    了解更多
                  </Link>
                </div>
              </div>
            </div>
          </section>

          <section className="py-14 md:py-20 bg-background-100">
            <div className="max-w-7xl mx-auto px-4 md:px-6">
              <div className="text-center mb-10 md:mb-14">
                <h2 className="text-xl md:text-3xl font-heading font-semibold text-foreground-900 mb-3">
                  探索分类
                </h2>
                <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
                  从尺码测量到日常穿搭，为你提供全方位的内衣选购指南
                </p>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
                {categories.map((cat) => (
                  <CategoryCard key={cat.slug} category={cat} />
                ))}
              </div>
            </div>
          </section>

          <section className="py-14 md:py-20 bg-background-50">
            <div className="max-w-7xl mx-auto px-4 md:px-6">
              <div className="flex items-center justify-between mb-10 md:mb-14">
                <div>
                  <h2 className="text-xl md:text-3xl font-heading font-semibold text-foreground-900 mb-2">
                    精选文章
                  </h2>
                  <p className="text-sm text-foreground-600">
                    最受大胸姐妹欢迎的实用指南
                  </p>
                </div>
                <Link
                  to="/category/zhao-bei-ce-liang"
                  className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap cursor-pointer"
                >
                  查看全部 <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
                {featuredArticles.map((article) => (
                  <ArticleCard key={article.slug} article={article} />
                ))}
              </div>
              <div className="mt-8 text-center sm:hidden">
                <Link
                  to="/category/zhao-bei-ce-liang"
                  className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap cursor-pointer"
                >
                  查看全部文章 <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>
          </section>

          <section className="py-14 md:py-20 bg-background-100">
            <div className="max-w-3xl mx-auto px-4 md:px-6">
              <div className="text-center mb-10 md:mb-14">
                <h2 className="text-xl md:text-3xl font-heading font-semibold text-foreground-900 mb-3">
                  常见问题
                </h2>
                <p className="text-sm md:text-base text-foreground-600">
                  大胸姐妹最常问的内衣相关问题
                </p>
              </div>
              <div className="flex flex-col gap-3">
                {faqData.map((item, index) => (
                  <div
                    key={index}
                    className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden"
                  >
                    <button
                      className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer"
                      onClick={() => setOpenFaq(openFaq === index ? null : index)}
                    >
                      <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                        {item.q}
                      </span>
                      <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                        <i
                          className={`text-foreground-400 transition-transform duration-200 ${
                            openFaq === index ? 'ri-subtract-line' : 'ri-add-line'
                          }`}
                        ></i>
                      </div>
                    </button>
                    {openFaq === index && (
                      <div className="px-4 md:px-5 pb-4 md:pb-5">
                        <p className="text-sm text-foreground-600 leading-relaxed">
                          {item.a}
                        </p>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section className="py-14 md:py-20 bg-accent-50">
            <div className="max-w-7xl mx-auto px-4 md:px-6 text-center">
              <h2 className="text-xl md:text-3xl font-heading font-semibold text-foreground-900 mb-3">
                关于我们
              </h2>
              <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto mb-6">
                我们是一群关注大胸女性穿着体验的内容创作者，致力于为大胸姐妹提供最专业、最贴心的内衣选购与穿搭建议。
              </p>
              <Link
                to="/about"
                className="inline-flex items-center gap-2 px-6 py-3 bg-accent-500 text-background-50 rounded-full text-sm font-medium hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                了解更多关于我们 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}